module.exports = __webpack_public_path__ + "assets/svg/Icons/32/shift-offer-red-77f9cf.svg";